<template >
  <div class="input-group mb-3">
    <span class="input-group-text">Lat</span>
    <input
        v-model="inputModel.latitude"
        type="number"
        step="0.000001"
        class="form-control"
        placeholder="Latitude"
    >
    <!--  required -->
    <span class="input-group-text">Lng</span>
    <input
        v-model="inputModel.longitude"
        type="number"
        step="0.000001"
        class="form-control"
        placeholder="Longitude"
    >
  </div>
</template>

<script>
import DisplayDebug from "@/components/general/DisplayDebug.vue";
let timerModel;
export default {
  name: "GpsInput",
  components: {
    DisplayDebug,
  },
  props: {
    "inputObj": Object,
    "formObj": Object,
    "modelValue": Object, Array,
    "activeLang": {
      type: [String],
      required: false,
      default: null,
    },
  },
  data() {
    return {
      inputModel: {
        "latitude": null,
        "longitude": null
      },
      is_locked: false,
      timer: null,
      timer_delay: 700,
    }
  },
  mounted() {
    if(
        this.inputObj.val != null
        && typeof this.inputObj.val == "object"
    ) {
      this.inputModel = this.inputObj.val;
    }
  },
  methods: {
  },
  watch: {

    inputObj: {
      handler() {
        if(
            this.inputObj.val != null
            && typeof this.inputObj.val == "object"
        ) {
          this.inputModel = this.inputObj.val;
        }
      },
      deep: true,
      immediate: true
    },

    inputModel: {
      handler(newVal) {
        if(timerModel) clearInterval(timerModel);
        timerModel = setTimeout(
            () => {
              this.$emit('update:modelValue', newVal )
            },
            this.timer_delay
        )
      },
      deep: true,
      immediate: true
    },
  },
};
</script>